import React from 'react';
import ReactLoading from 'react-loading';
 
const Loading = ({ type, color }) => (
    <ReactLoading type={'bubbles'} color={'blue'} height={'10%'} width={'10%'} />
);
 
export default Loading;


